<template>
  <div>
    <vue-title :title="$t('profile.title')" />
    <v-card-text class="v-card__text">
      <v-form ref="form">
        <v-text-field name="firstname" :label="$t('profile.firstname')" type="text" v-model="user.firstName" :rules="[rules.required]"></v-text-field>
        <v-text-field name="lastname" :label="$t('profile.lastname')" type="text" v-model="user.lastName" :rules="[rules.required]"></v-text-field>
        <v-text-field name="email" :label="$t('profile.email')" type="text" v-model="user.email" disabled></v-text-field>
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              :rules="[rules.required]"
              v-model="formattedDate"
              :label="$t('profile.dateofbirth')"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker min="1919-01-01"
             v-model="dateofbirth" no-title @input="menu = false"
            :locale="$i18n.locale" first-day-of-week="1" ref="picker"></v-date-picker>
        </v-menu>
        <v-radio-group v-model="user.gender" row>
          {{ $t('profile.gender') }} &nbsp;
          <v-radio :label="$t('profile.male')" color="red" :value="0"></v-radio>
          <v-radio :label="$t('profile.female')" color="red" :value="1"></v-radio>
        </v-radio-group>
        <v-select v-model="user.shirtSize" :items="shirtSizes" :rules="[rules.required]" :label="$t('competitor.shirtSize')"></v-select>
        <v-select :items="Object.keys(this.$i18n.messages)" :label="$t('ctrl.language')" v-model="user.language"
          @change="changeLocale()">
          <template slot="selection" slot-scope="data">
              <flag :iso="data.item|localeToCountry" />&nbsp; {{ $t('langNative.'+data.item) }}
          </template>
          <template slot="item" slot-scope="data">
              <flag :iso="data.item|localeToCountry" />&nbsp; {{ $t('langNative.'+data.item) }}
          </template>
      </v-select>
        <v-text-field name="address" :label="$t('profile.address')" type="text" v-model="user.address" :rules="[rules.required]"></v-text-field>
        <fcc-country :competitor="user" :rules="[rules.required]" />
        <v-text-field name="telephone" :label="$t('profile.telephone')" type="text" v-model="user.telephone" :rules="[rules.required]"></v-text-field>
        <v-text-field name="department" :label="$t('competitor.department')" type="text" v-model="user.department" :rules="[rules.required]"></v-text-field>
        <v-checkbox color="red" :rules="[rules.required]" :label="$t('application.submitTerms')"></v-checkbox>
      </v-form>
    </v-card-text>
    <v-card-actions class="v-card__actions">
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="save">{{ $t("ctrl.save") }}</v-btn>
    </v-card-actions>
    <v-snackbar
      v-model="snackbar"
      :bottom="true"
      :timeout="5000">
      {{ $t('profile.saved') }}
      <v-btn
        color="red"
        text
        @click="snackbar = false">
        {{ $t('ctrl.close') }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import {
    VCardActions,
    VCardText,
    VForm,
    VDatePicker,
    VRadioGroup,
    VRadio,
    VMenu,
    VTextField,
    VSelect,
    VSnackbar,
    VCheckbox
  } from 'vuetify/lib'
  import FCCCountry from '../components/FCCCountry'
  import fccapi from '../fccapi';

  export default {
    name: 'Profile',
    data: () => ({
      dateofbirth: null,
      user: {},
      snackbar: false,
      menu: false,
      shirtSizes: ["S", "M", "L", "XL"],
    }),
    computed: {
      genders: function () { 
        return [this.$t("profile.male"), this.$t("profile.female")]
      },
      formattedDate: function(){
        if(!this.dateofbirth) return "";
        var parts = this.dateofbirth.split('-');
        return parts[2]+"."+parts[1]+"."+parts[0];
      },
      rules: function() {
        return {
          required: value =>  !!value || this.$t('registration.required')
        }
      },
    },
    mounted: function(){
      this.user = this.$store.getters['user'];
      this.dateofbirth = this.user.dateOfBirth.split('T')[0];
    },
    methods: {
      save: function(){
        if(this.$refs.form.validate()){
          this.user.dateOfBirth = this.dateofbirth;
          fccapi.post('user', this.user).then(r => {
            console.log(r);
            this.snackbar = true;
            this.$store.dispatch('loadBaseData')
          }).catch(e => {
            console.log(e);
          })
        }
      },
      changeLocale(){
        this.$i18n.locale = this.user.language
      },
    },
    props: {
      source: String
    },
    components: {
      VForm,
      VTextField,
      VRadioGroup,
      VRadio,
      VCardActions,
      VCardText,
      VSelect,
      VDatePicker,
      VMenu,
      VSnackbar,
      VCheckbox,
      "fcc-country": FCCCountry,
    }
  }
</script>